const DATOS = 

[
  {
    "id_familia": 0,
    "nombre_familia": "Cerveza",
    "superfamilia": "Bebestible",
    "id": 0,
    "precio": 4500,
    "nombre": "Kunstmann 500 cc",
    "descripcion": "Torobayo, Miel"
  },
  {
    "id_familia": 0,
    "nombre_familia": "Cerveza",
    "superfamilia": "Bebestible",
    "id": 6,
    "precio": 3200,
    "nombre": "Kunstmann 330 cc",
    "descripcion": "Valdivia"
  },
  {
    "id_familia": 0,
    "nombre_familia": "Cerveza",
    "superfamilia": "Bebestible",
    "id": 7,
    "precio": 3200,
    "nombre": "Kross 330 cc",
    "descripcion": "Golden-Pilsen-Stout-Maibox"
  },
  {
    "id_familia": 0,
    "nombre_familia": "Cerveza",
    "superfamilia": "Bebestible",
    "id": 8,
    "precio": 3500,
    "nombre": "Kross 5 - 330 cc",
    "descripcion": "kross 5"
  },
  {
    "id_familia": 0,
    "nombre_familia": "Cerveza",
    "superfamilia": "Bebestible",
    "id": 10,
    "precio": 4500,
    "nombre": "Austral 500 cc",
    "descripcion": "Calafate"
  },
  {
    "id_familia": 0,
    "nombre_familia": "Cerveza",
    "superfamilia": "Bebestible",
    "id": 15,
    "precio": 3200,
    "nombre": "Austral 330 cc",
    "descripcion": "Lager"
  },
  {
    "id_familia": 0,
    "nombre_familia": "Cerveza",
    "superfamilia": "Bebestible",
    "id": 60,
    "precio": 3500,
    "nombre": "Patagonia 470 cc",
    "descripcion": "Hoppy, Red, blond lager"
  },
  {
    "id_familia": 0,
    "nombre_familia": "Cerveza",
    "superfamilia": "Bebestible",
    "id": 61,
    "precio": 4600,
    "nombre": "Royal - Heineken",
    "descripcion": "1 Lt"
  },
  {
    "id_familia": 0,
    "nombre_familia": "Cerveza",
    "superfamilia": "Bebestible",
    "id": 63,
    "precio": 3000,
    "nombre": "Heineken 330 cc",
    "descripcion": "Sin alcohol"
  },
  {
    "id_familia": 0,
    "nombre_familia": "Cerveza",
    "superfamilia": "Bebestible",
    "id": 64,
    "precio": 3200,
    "nombre": "Corona 330 cc",
    "descripcion": "Cerveza Lager"
  },
  {
    "id_familia": 0,
    "nombre_familia": "Cerveza",
    "superfamilia": "Bebestible",
    "id": 119,
    "precio": 3800,
    "nombre": "Reeper B. IPA 500 cc",
    "descripcion": "IPA 5 °"
  },
  {
    "id_familia": 0,
    "nombre_familia": "Cerveza",
    "superfamilia": "Bebestible",
    "id": 122,
    "precio": 2800,
    "nombre": "Lemon Stones",
    "descripcion": "Lata"
  },
  {
    "id_familia": 0,
    "nombre_familia": "Cerveza",
    "superfamilia": "Bebestible",
    "id": 127,
    "precio": 2800,
    "nombre": "Lemon Mango",
    "descripcion": "Lata"
  },
  {
    "id_familia": 0,
    "nombre_familia": "Cerveza",
    "superfamilia": "Bebestible",
    "id": 129,
    "precio": 2800,
    "nombre": "Lemon Maracuya",
    "descripcion": "Lata"
  },
  {
    "id_familia": 0,
    "nombre_familia": "Cerveza",
    "superfamilia": "Bebestible",
    "id": 135,
    "precio": 4500,
    "nombre": "Dolbek Maqui",
    "descripcion": "500 cc"
  },
  {
    "id_familia": 0,
    "nombre_familia": "Cerveza",
    "superfamilia": "Bebestible",
    "id": 139,
    "precio": 3200,
    "nombre": "Austral Sin Filtrar ",
    "descripcion": "Sin Filtrar"
  },
  {
    "id_familia": 1,
    "nombre_familia": "Schop",
    "superfamilia": "Bebestible",
    "id": 66,
    "precio": 4500,
    "nombre": "Calafate",
    "descripcion": "500 cc"
  },
  {
    "id_familia": 1,
    "nombre_familia": "Schop",
    "superfamilia": "Bebestible",
    "id": 70,
    "precio": 3000,
    "nombre": "Cristal",
    "descripcion": "500 cc"
  },
  {
    "id_familia": 1,
    "nombre_familia": "Schop",
    "superfamilia": "Bebestible",
    "id": 123,
    "precio": 4500,
    "nombre": "Torres del Paine",
    "descripcion": "500 cc"
  },
  {
    "id_familia": 1,
    "nombre_familia": "Schop",
    "superfamilia": "Bebestible",
    "id": 128,
    "precio": 700,
    "nombre": "Vaso Michelado",
    "descripcion": "limon"
  },
  {
    "id_familia": 2,
    "nombre_familia": "Pisco",
    "superfamilia": "Bebestible",
    "id": 42,
    "precio": 3500,
    "nombre": "Mistral 35°",
    "descripcion": "incluye Bebida"
  },
  {
    "id_familia": 2,
    "nombre_familia": "Pisco",
    "superfamilia": "Bebestible",
    "id": 43,
    "precio": 3900,
    "nombre": "Mistral 40°",
    "descripcion": "incluye Bebida"
  },
  {
    "id_familia": 2,
    "nombre_familia": "Pisco",
    "superfamilia": "Bebestible",
    "id": 44,
    "precio": 4900,
    "nombre": "Mistral Nobel",
    "descripcion": "incluye Bebida"
  },
  {
    "id_familia": 2,
    "nombre_familia": "Pisco",
    "superfamilia": "Bebestible",
    "id": 45,
    "precio": 4900,
    "nombre": "Mistral Manzana",
    "descripcion": "Inclute Bebida"
  },
  {
    "id_familia": 2,
    "nombre_familia": "Pisco",
    "superfamilia": "Bebestible",
    "id": 48,
    "precio": 4900,
    "nombre": "Mistral Honey",
    "descripcion": "mistral nobel honey"
  },
  {
    "id_familia": 2,
    "nombre_familia": "Pisco",
    "superfamilia": "Bebestible",
    "id": 52,
    "precio": 3500,
    "nombre": "Pisco sour",
    "descripcion": "Pisco sour"
  },
  {
    "id_familia": 2,
    "nombre_familia": "Pisco",
    "superfamilia": "Bebestible",
    "id": 65,
    "precio": 4900,
    "nombre": "Pisco Sour Tabernero",
    "descripcion": "Sour Pisco Peruano"
  },
  {
    "id_familia": 2,
    "nombre_familia": "Pisco",
    "superfamilia": "Bebestible",
    "id": 105,
    "precio": 3900,
    "nombre": "Gobernador 35°",
    "descripcion": "incluye Bebida"
  },
  {
    "id_familia": 2,
    "nombre_familia": "Pisco",
    "superfamilia": "Bebestible",
    "id": 106,
    "precio": 3500,
    "nombre": "Primavera",
    "descripcion": "Con y Sin Alcohol"
  },
  {
    "id_familia": 2,
    "nombre_familia": "Pisco",
    "superfamilia": "Bebestible",
    "id": 107,
    "precio": 6000,
    "nombre": "Piscolon Mistral 35",
    "descripcion": "Incluye Bebida"
  },
  {
    "id_familia": 2,
    "nombre_familia": "Pisco",
    "superfamilia": "Bebestible",
    "id": 136,
    "precio": 7000,
    "nombre": "Piscolon Mistral 40",
    "descripcion": "Incluye Bebida"
  },
  {
    "id_familia": 2,
    "nombre_familia": "Pisco",
    "superfamilia": "Bebestible",
    "id": 147,
    "precio": 9000,
    "nombre": "Piscolon Nobel",
    "descripcion": "Incluye Bebida"
  },
  {
    "id_familia": 2,
    "nombre_familia": "Pisco",
    "superfamilia": "Bebestible",
    "id": 149,
    "precio": 3000,
    "nombre": "Mistral ice",
    "descripcion": "Mistral ice"
  },
  {
    "id_familia": 3,
    "nombre_familia": "Chorrillanas",
    "superfamilia": "Comida",
    "id": 12,
    "precio": 7900,
    "nombre": "Chorri - Cívica",
    "descripcion": "Carne, Papas fritas, Huevo, Cebolla, Chorizo"
  },
  {
    "id_familia": 3,
    "nombre_familia": "Chorrillanas",
    "superfamilia": "Comida",
    "id": 13,
    "precio": 8900,
    "nombre": "Chorri - Mechada",
    "descripcion": "Mechada, Papas fritas, Huevo, Cebolla, Chorizo"
  },
  {
    "id_familia": 4,
    "nombre_familia": "Pizzas medianas",
    "superfamilia": "Comida",
    "id": 16,
    "precio": 5500,
    "nombre": "Margarita",
    "descripcion": "Queso - Tomate - Aceituna"
  },
  {
    "id_familia": 4,
    "nombre_familia": "Pizzas medianas",
    "superfamilia": "Comida",
    "id": 17,
    "precio": 5500,
    "nombre": "Vegetariana",
    "descripcion": "Queso - Pimentón - Champiñón - Cebolla Caramelizada"
  },
  {
    "id_familia": 4,
    "nombre_familia": "Pizzas medianas",
    "superfamilia": "Comida",
    "id": 146,
    "precio": 5500,
    "nombre": "Camarón",
    "descripcion": "Camarón - Tocino - Cebolla Caramelizada"
  },
  {
    "id_familia": 6,
    "nombre_familia": "Ron",
    "superfamilia": "Bebestible",
    "id": 50,
    "precio": 5300,
    "nombre": "Havana 7 Años",
    "descripcion": "incluye Bebida"
  },
  {
    "id_familia": 6,
    "nombre_familia": "Ron",
    "superfamilia": "Bebestible",
    "id": 51,
    "precio": 4200,
    "nombre": "Havana Reserva",
    "descripcion": "incluye Bebida"
  },
  {
    "id_familia": 6,
    "nombre_familia": "Ron",
    "superfamilia": "Bebestible",
    "id": 59,
    "precio": 3500,
    "nombre": "Havana Especial",
    "descripcion": "incluye Bebida"
  },
  {
    "id_familia": 6,
    "nombre_familia": "Ron",
    "superfamilia": "Bebestible",
    "id": 62,
    "precio": 3900,
    "nombre": "Mojito XL",
    "descripcion": "Mojito XL"
  },
  {
    "id_familia": 6,
    "nombre_familia": "Ron",
    "superfamilia": "Bebestible",
    "id": 67,
    "precio": 3500,
    "nombre": "Caipirissima",
    "descripcion": "Coctel"
  },
  {
    "id_familia": 6,
    "nombre_familia": "Ron",
    "superfamilia": "Bebestible",
    "id": 125,
    "precio": 4200,
    "nombre": "Cubaney",
    "descripcion": "incluye bebida"
  },
  {
    "id_familia": 8,
    "nombre_familia": "Hamburguesas 200 g",
    "superfamilia": "Comida",
    "id": 21,
    "precio": 4500,
    "nombre": "Cívica",
    "descripcion": "Queso, Porotos Verdes, Tomate, Mayo"
  },
  {
    "id_familia": 8,
    "nombre_familia": "Hamburguesas 200 g",
    "superfamilia": "Comida",
    "id": 22,
    "precio": 4500,
    "nombre": "Bacon",
    "descripcion": "Tocino, Cebolla acaramelada, Mayo, Queso"
  },
  {
    "id_familia": 8,
    "nombre_familia": "Hamburguesas 200 g",
    "superfamilia": "Comida",
    "id": 23,
    "precio": 4500,
    "nombre": "Turda",
    "descripcion": "Cebolla morada acaramelada, Aceitunas, Queso"
  },
  {
    "id_familia": 8,
    "nombre_familia": "Hamburguesas 200 g",
    "superfamilia": "Comida",
    "id": 24,
    "precio": 4500,
    "nombre": "Pepinillo",
    "descripcion": "Pepinillo, Tomate, Salsa, Queso"
  },
  {
    "id_familia": 60,
    "nombre_familia": "Sandwichs",
    "superfamilia": "Comida",
    "id": 25,
    "precio": 3500,
    "nombre": "Mechada Queso",
    "descripcion": "Mechada, Queso"
  },
  {
    "id_familia": 60,
    "nombre_familia": "Sandwichs",
    "superfamilia": "Comida",
    "id": 26,
    "precio": 4200,
    "nombre": "Mechada chacarera",
    "descripcion": "Carne mechada, Porotos verdes, Ají, Tomate"
  },
  {
    "id_familia": 60,
    "nombre_familia": "Sandwichs",
    "superfamilia": "Comida",
    "id": 27,
    "precio": 3500,
    "nombre": "Barros luco",
    "descripcion": "Carne, Queso"
  },
  {
    "id_familia": 60,
    "nombre_familia": "Sandwichs",
    "superfamilia": "Comida",
    "id": 28,
    "precio": 3900,
    "nombre": "Chacarero",
    "descripcion": "Carne, Porotos verdes, Ají, Tomate"
  },
  {
    "id_familia": 62,
    "nombre_familia": "Tablas",
    "superfamilia": "Comida",
    "id": 31,
    "precio": 6200,
    "nombre": "Cívica",
    "descripcion": "Queso, Galletas, Pickles, Frutos Secos, Salame, Salsa"
  },
  {
    "id_familia": 62,
    "nombre_familia": "Tablas",
    "superfamilia": "Comida",
    "id": 112,
    "precio": 3200,
    "nombre": "Aceitunas maceradas",
    "descripcion": "Aceitunas macerada"
  },
  {
    "id_familia": 99,
    "nombre_familia": "Vodka",
    "superfamilia": "Bebestible",
    "id": 71,
    "precio": 3900,
    "nombre": "Stolishnaya",
    "descripcion": "incluye Bebida"
  },
  {
    "id_familia": 99,
    "nombre_familia": "Vodka",
    "superfamilia": "Bebestible",
    "id": 72,
    "precio": 4100,
    "nombre": "Absolut Blue",
    "descripcion": "incluye Bebida"
  },
  {
    "id_familia": 99,
    "nombre_familia": "Vodka",
    "superfamilia": "Bebestible",
    "id": 73,
    "precio": 4500,
    "nombre": "Absolut Sabores",
    "descripcion": "Pears,Raspberry"
  },
  {
    "id_familia": 99,
    "nombre_familia": "Vodka",
    "superfamilia": "Bebestible",
    "id": 74,
    "precio": 3500,
    "nombre": "Caipiroska",
    "descripcion": "Coctel"
  },
  {
    "id_familia": 99,
    "nombre_familia": "Vodka",
    "superfamilia": "Bebestible",
    "id": 75,
    "precio": 3500,
    "nombre": "Laguna Azul",
    "descripcion": "Coctel"
  },
  {
    "id_familia": 99,
    "nombre_familia": "Vodka",
    "superfamilia": "Bebestible",
    "id": 113,
    "precio": 3500,
    "nombre": "Spirit",
    "descripcion": "BlueBerry-PineApple"
  },
  {
    "id_familia": 103,
    "nombre_familia": "Tequila",
    "superfamilia": "Bebestible",
    "id": 76,
    "precio": 3900,
    "nombre": "Tequilazo",
    "descripcion": "1 shot, Tequila, limón"
  },
  {
    "id_familia": 103,
    "nombre_familia": "Tequila",
    "superfamilia": "Bebestible",
    "id": 77,
    "precio": 3500,
    "nombre": "Golpeados",
    "descripcion": "2 Shot, limon, bebida y sal"
  },
  {
    "id_familia": 103,
    "nombre_familia": "Tequila",
    "superfamilia": "Bebestible",
    "id": 78,
    "precio": 3500,
    "nombre": "Margarita",
    "descripcion": "limón - Azúcar Flor - Triple Sec"
  },
  {
    "id_familia": 103,
    "nombre_familia": "Tequila",
    "superfamilia": "Bebestible",
    "id": 79,
    "precio": 3500,
    "nombre": "Sunrise",
    "descripcion": "jugo de Naranja - Granadina"
  },
  {
    "id_familia": 103,
    "nombre_familia": "Tequila",
    "superfamilia": "Bebestible",
    "id": 81,
    "precio": 3700,
    "nombre": "Tequiriña",
    "descripcion": "Limón amacerado - Soda"
  },
  {
    "id_familia": 104,
    "nombre_familia": "Whisky",
    "superfamilia": "Bebestible",
    "id": 82,
    "precio": 3900,
    "nombre": "Ballantine",
    "descripcion": "En las Rocas"
  },
  {
    "id_familia": 104,
    "nombre_familia": "Whisky",
    "superfamilia": "Bebestible",
    "id": 84,
    "precio": 5900,
    "nombre": "Jack Daniel's",
    "descripcion": "N7 - Honey - Manzana - Fire"
  },
  {
    "id_familia": 104,
    "nombre_familia": "Whisky",
    "superfamilia": "Bebestible",
    "id": 85,
    "precio": 4200,
    "nombre": "JW Red Label",
    "descripcion": "En las Rocas"
  },
  {
    "id_familia": 104,
    "nombre_familia": "Whisky",
    "superfamilia": "Bebestible",
    "id": 87,
    "precio": 5900,
    "nombre": "Clavo Oxidado",
    "descripcion": "Ballantine - Drambui"
  },
  {
    "id_familia": 104,
    "nombre_familia": "Whisky",
    "superfamilia": "Bebestible",
    "id": 124,
    "precio": 4500,
    "nombre": "Baileys",
    "descripcion": "Baileys"
  },
  {
    "id_familia": 104,
    "nombre_familia": "Whisky",
    "superfamilia": "Bebestible",
    "id": 134,
    "precio": 4700,
    "nombre": "Mojito Whisky",
    "descripcion": "whisky"
  },
  {
    "id_familia": 105,
    "nombre_familia": "Gin",
    "superfamilia": "Bebestible",
    "id": 88,
    "precio": 4900,
    "nombre": "Beefeter",
    "descripcion": "incluye Bebida"
  },
  {
    "id_familia": 105,
    "nombre_familia": "Gin",
    "superfamilia": "Bebestible",
    "id": 89,
    "precio": 4900,
    "nombre": "Bombay",
    "descripcion": "incluye Bebida"
  },
  {
    "id_familia": 105,
    "nombre_familia": "Gin",
    "superfamilia": "Bebestible",
    "id": 90,
    "precio": 4900,
    "nombre": "Tanqueray",
    "descripcion": "incluye Bebida"
  },
  {
    "id_familia": 106,
    "nombre_familia": "Otros",
    "superfamilia": "Bebestible",
    "id": 91,
    "precio": 3500,
    "nombre": "Caipirinha",
    "descripcion": "Cachaza-Limon"
  },
  {
    "id_familia": 106,
    "nombre_familia": "Otros",
    "superfamilia": "Bebestible",
    "id": 92,
    "precio": 3500,
    "nombre": "Vaina",
    "descripcion": "Vino Dulce-Coñac"
  },
  {
    "id_familia": 106,
    "nombre_familia": "Otros",
    "superfamilia": "Bebestible",
    "id": 93,
    "precio": 3500,
    "nombre": "Amaretto",
    "descripcion": "Licor de Almendras"
  },
  {
    "id_familia": 106,
    "nombre_familia": "Otros",
    "superfamilia": "Bebestible",
    "id": 94,
    "precio": 3500,
    "nombre": "Alexander",
    "descripcion": "Cacao-Crema-Coñac"
  },
  {
    "id_familia": 106,
    "nombre_familia": "Otros",
    "superfamilia": "Bebestible",
    "id": 95,
    "precio": 3900,
    "nombre": "Campari",
    "descripcion": "Tradicional"
  },
  {
    "id_familia": 106,
    "nombre_familia": "Otros",
    "superfamilia": "Bebestible",
    "id": 114,
    "precio": 4900,
    "nombre": "Aperol Spritz",
    "descripcion": "aperol - espumante - soda"
  },
  {
    "id_familia": 106,
    "nombre_familia": "Otros",
    "superfamilia": "Bebestible",
    "id": 115,
    "precio": 5200,
    "nombre": "Ramazzotti Violet Sp",
    "descripcion": "Ramazzotti - espumante - soda"
  },
  {
    "id_familia": 106,
    "nombre_familia": "Otros",
    "superfamilia": "Bebestible",
    "id": 116,
    "precio": 5200,
    "nombre": "Ramazzotti Spritz",
    "descripcion": "Ramazzotti - espumante - soda"
  },
  {
    "id_familia": 106,
    "nombre_familia": "Otros",
    "superfamilia": "Bebestible",
    "id": 133,
    "precio": 5200,
    "nombre": "Mojito Jager",
    "descripcion": "jaguer"
  },
  {
    "id_familia": 106,
    "nombre_familia": "Otros",
    "superfamilia": "Bebestible",
    "id": 137,
    "precio": 7000,
    "nombre": "Botella Colemono",
    "descripcion": "colemono"
  },
  {
    "id_familia": 106,
    "nombre_familia": "Otros",
    "superfamilia": "Bebestible",
    "id": 138,
    "precio": 3500,
    "nombre": "Terremoto",
    "descripcion": "Pipeño - helado piña - granadina"
  },
  {
    "id_familia": 106,
    "nombre_familia": "Otros",
    "superfamilia": "Bebestible",
    "id": 148,
    "precio": 8500,
    "nombre": "Cola de Mono Casero",
    "descripcion": "Cola de Mono Casero"
  },
  {
    "id_familia": 107,
    "nombre_familia": "Cocteles Civico",
    "superfamilia": "Bebestible",
    "id": 96,
    "precio": 3500,
    "nombre": "Chaplin",
    "descripcion": "Ron-Vermouth-Piña"
  },
  {
    "id_familia": 107,
    "nombre_familia": "Cocteles Civico",
    "superfamilia": "Bebestible",
    "id": 97,
    "precio": 3500,
    "nombre": "Emigrante",
    "descripcion": "Gin-Vermouth-Piña-Curazao"
  },
  {
    "id_familia": 107,
    "nombre_familia": "Cocteles Civico",
    "superfamilia": "Bebestible",
    "id": 98,
    "precio": 3500,
    "nombre": "Gladys",
    "descripcion": "Ron-Vermouth-Limón-Granadina"
  },
  {
    "id_familia": 107,
    "nombre_familia": "Cocteles Civico",
    "superfamilia": "Bebestible",
    "id": 99,
    "precio": 3500,
    "nombre": "Hora Cero",
    "descripcion": "Ron-Naranja-Limón"
  },
  {
    "id_familia": 107,
    "nombre_familia": "Cocteles Civico",
    "superfamilia": "Bebestible",
    "id": 100,
    "precio": 3500,
    "nombre": "Luna LLena",
    "descripcion": "Pisco-Piña-Crema"
  },
  {
    "id_familia": 107,
    "nombre_familia": "Cocteles Civico",
    "superfamilia": "Bebestible",
    "id": 101,
    "precio": 3500,
    "nombre": "Norteño",
    "descripcion": "Pisco-Papaya-Limón"
  },
  {
    "id_familia": 107,
    "nombre_familia": "Cocteles Civico",
    "superfamilia": "Bebestible",
    "id": 102,
    "precio": 3500,
    "nombre": "Sureño",
    "descripcion": "Pisco-Limón-Curazao"
  },
  {
    "id_familia": 107,
    "nombre_familia": "Cocteles Civico",
    "superfamilia": "Bebestible",
    "id": 104,
    "precio": 4500,
    "nombre": "Civico",
    "descripcion": "Whisky-Ron-Crema"
  },
  {
    "id_familia": 108,
    "nombre_familia": "Vinos",
    "superfamilia": "Bebestible",
    "id": 38,
    "precio": 3200,
    "nombre": "Misiones Botellin",
    "descripcion": "Tinto"
  },
  {
    "id_familia": 108,
    "nombre_familia": "Vinos",
    "superfamilia": "Bebestible",
    "id": 39,
    "precio": 8900,
    "nombre": "Doña Dominga Varieta",
    "descripcion": "Cabernet-Carmene"
  },
  {
    "id_familia": 108,
    "nombre_familia": "Vinos",
    "superfamilia": "Bebestible",
    "id": 40,
    "precio": 12300,
    "nombre": "Adobe Reserva",
    "descripcion": "Cabernet-Carmene"
  },
  {
    "id_familia": 108,
    "nombre_familia": "Vinos",
    "superfamilia": "Bebestible",
    "id": 41,
    "precio": 15000,
    "nombre": "Toro de Piedra",
    "descripcion": "Cabernet-Carmene"
  },
  {
    "id_familia": 109,
    "nombre_familia": "Bebidas",
    "superfamilia": "Bebestible",
    "id": 34,
    "precio": 2000,
    "nombre": "Agua mineral",
    "descripcion": "Con Gas y Sin Gas"
  },
  {
    "id_familia": 109,
    "nombre_familia": "Bebidas",
    "superfamilia": "Bebestible",
    "id": 35,
    "precio": 2300,
    "nombre": "Bebidas",
    "descripcion": "Coca-Fanta-Sprite"
  },
  {
    "id_familia": 109,
    "nombre_familia": "Bebidas",
    "superfamilia": "Bebestible",
    "id": 37,
    "precio": 3000,
    "nombre": "Red Bull",
    "descripcion": "Azul"
  },
  {
    "id_familia": 111,
    "nombre_familia": "Papas",
    "superfamilia": "Comida",
    "id": 117,
    "precio": 3900,
    "nombre": "Papas Civicas",
    "descripcion": "papas baston"
  },
  {
    "id_familia": 111,
    "nombre_familia": "Papas",
    "superfamilia": "Comida",
    "id": 145,
    "precio": 4500,
    "nombre": "Papas Rusticas",
    "descripcion": "papa rustica con tomate"
  },
  {
    "id_familia": 112,
    "nombre_familia": "Promos",
    "superfamilia": "Comida",
    "id": 140,
    "precio": 7900,
    "nombre": "Promo hamburguesa",
    "descripcion": "Hamburguesa a eleccion + schop calafate"
  },
  {
    "id_familia": 112,
    "nombre_familia": "Promos",
    "superfamilia": "Comida",
    "id": 141,
    "precio": 12900,
    "nombre": "Promo pizza",
    "descripcion": "Pizza a eleccion + 2 schop calafate"
  },
  {
    "id_familia": 112,
    "nombre_familia": "Promos",
    "superfamilia": "Comida",
    "id": 142,
    "precio": 14900,
    "nombre": "Promo Chorrillana",
    "descripcion": "Chorricivica + 2 schop calafate"
  }
]

export default DATOS;